import { render, staticRenderFns } from "./ControlloUtenti.vue?vue&type=template&id=e7f0ed0a"
import script from "./ControlloUtenti.vue?vue&type=script&lang=js"
export * from "./ControlloUtenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports